export default __webpack_public_path__ + "static/media/tree7.ad83083d.png";